// Routes des travaux et chantiers (lot L4-C, M14), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageProjet } from './PageProjet';
import { PageProjets } from './PageProjets';

export const routesTravaux: RouteObject[] = [
  { path: '/travaux', element: <PageProjets /> },
  { path: '/travaux/:id', element: <PageProjet /> },
];
